<template>
  <main class="content">
    <headerCustom :name="translation.NAME" :logo="translation.LOGO" :lang="language" @changeLang="changeLanguage" />
    <section class="container-fluid p-0 main-section">
      <b-container fluid="xl" class="form-container">
        <transition name="fade-up" appear>
          <b-row no-gutters class="shadow-lg overflow-hidden card-container">
            <!-- Columna Izquierda: Contenido Motivador con SVGs -->
            <b-col cols="12" md="6" class="d-none d-md-block p-0">
              <div class="form__description">
                <div class="visual-elements">
                  <div class="svg-blob blob-1"></div>
                  <div class="svg-blob blob-2"></div>
                  <div class="svg-blob blob-3"></div>
                  <!-- Iconos Flotantes que representan valores -->
                  <div class="floating-icons">
                    <!-- Inteligencia / IA -->
                    <div class="f-icon icon-1">
                      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="white" stroke-opacity="0.2" stroke-width="2"/><path d="M12 16L16 12L12 8L8 12L12 16Z" fill="white" fill-opacity="0.3"/></svg>
                    </div>
                    <!-- Rentabilidad / Gráfico -->
                    <div class="f-icon icon-2">
                      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23 6L13.5 15.5L8.5 10.5L1 18" stroke="white" stroke-opacity="0.2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M17 6H23V12" stroke="white" stroke-opacity="0.2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    </div>
                    <!-- Simplicidad / Check -->
                    <div class="f-icon icon-3">
                      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 6L9 17L4 12" stroke="white" stroke-opacity="0.2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    </div>
                    <!-- Proceso / Engranaje -->
                    <div class="f-icon icon-4">
                      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="3" stroke="white" stroke-opacity="0.2" stroke-width="2"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" stroke="white" stroke-opacity="0.2" stroke-width="2"/></svg>
                    </div>
                  </div>
                </div>
                <div class="description-content">
                  <img :src="translation.LOGO" alt="Logo" class="mb-4 brand-logo">
                  <h2 class="text-white font-weight-bold mb-3">{{ translation[language].title }}</h2>
                  <p class="text-white-50 description-text">{{ translation[language].description }}</p>
                  <div v-if="translation[language].stats && translation[language].stats.length" class="stats-mini mt-5">
                    <div v-for="(stat, index) in translation[language].stats" :key="index" class="stat-item">
                      <span class="stat-value">{{ stat.value }}</span>
                      <span class="stat-label">{{ stat.label }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
            <!-- Columna Derecha: Formulario de Login -->
            <b-col cols="12" md="6" class="p-0">
              <div class="form__content">
                <div class="text-center mb-4">
                  <h1 class="login-title">{{title[language]}}</h1>
                  <div class="title-underline"></div>
                </div>

                <div class="login-buttons-container">
                  <ButtonGoogleLogin
                        v-if="translation.AUTH['GOOGLE']"
                        :lang="language"
                        variant="outline-gray"
                        :urlcallback="translation.URLCALLBACK"
                        class="social-button"
                    />
                  <ButtonMicrosoftLogin
                      v-if="translation.AUTH['MICROSOFT']"
                      :lang="language"
                      variant="outline-gray"
                      class="social-button"
                    />
                  <ButtonLinkedInLogin
                    v-if="translation.AUTH['LINKEDIN']"
                    text="Sign in <b>with Linkedin</b>"
                    variant="outline-gray"
                    class="social-button"
                  />

                  <div class="divider">
                    <span>{{ language === 'ES' ? 'O' : (language === 'PT' ? 'OU' : (language === 'FR' ? 'OU' : 'OR')) }}</span>
                  </div>

                  <ButtonEmailVerification
                      v-if="translation.AUTH['OTP']"
                      variant="outline-gray"
                      :lang="language"
                      :channel="2"
                      type="LOGIN"
                      channelType="EMAIL"
                      class="otp-button"
                  />
                </div>

                <p class="policy-text mt-4">{{policy[language]}}</p>

                <div class="signup-section border-top pt-4 mt-4 text-center">
                  <p class="motivation-text mb-3">{{motivation_create_account[language]}}</p>
                  <div class="login-buttons-container">
                    <ButtonComponent
                      icon="arrow-right-circle-fill"
                      iconPosition="end"
                      :text="create_account[language]"
                      variant="orange"
                      href="/signup"
                      class="mt-0 signup-button"
                    />
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </transition>
      </b-container>

    </section>
    <footerCustom :lang="language" />
  </main>
</template>

<script>
import headerCustom from '../components/header.vue'
import footerCustom from '../components/footer.vue'
import ButtonEmailVerification from '../packages/systemico.ui/components/buttons/ButtonEmailVerification.vue'
import ButtonGoogleLogin from '../packages/systemico.ui/components/buttons/ButtonGoogleLogin.vue'
import ButtonLinkedInLogin from '../packages/systemico.ui/components/buttons/ButtonLinkedInLogin.vue'
import ButtonMicrosoftLogin from '../packages/systemico.ui/components/buttons/ButtonMicrosoftLogin.vue'
import ButtonComponent from '../packages/systemico.ui/components/buttons/ButtonComponent.vue'
import json from '../../../../lang/login.json'
export default {
  name: 'LoginView',
  components: {
    ButtonComponent,
    ButtonMicrosoftLogin,
    ButtonLinkedInLogin,
    ButtonGoogleLogin,
    ButtonEmailVerification,
    headerCustom,
    footerCustom
  },
  props: {
    lang: {
      type: String,
      default: 'EN'
    }
  },
  data: function () {
    return {
      translation: json,
      language: 'EN',
      title: {
        ES: 'Acceso Seguro',
        EN: 'Sign in now',
        PT: 'Acesso Seguro',
        FR: 'Accès Sécurisé'
      },
      policy: {
        ES: 'Cuando creas o accedes a tu cuenta aceptas nuestras políticas y términos.',
        EN: 'When you create an account you accept our policies and terms.',
        PT: 'Ao criar ou acessar sua conta, você aceita nossas políticas e termos.',
        FR: 'En créant ou en accédant à votre compte, vous acceptez nos politiques et conditions.'
      },
      motivation_create_account: {
        ES: '¿Listo para empezar?',
        EN: 'Ready to be an user?',
        PT: 'Pronto para começar?',
        FR: 'Prêt à commencer ?'
      },
      create_account: {
        ES: '<b>Crea</b> tu <b>cuenta gratis</b>',
        EN: '<b>Create</b> your <b>free account</b>',
        PT: '<b>Crie</b> sua <b>conta gratuita</b>',
        FR: '<b>Créez</b> votre <b>compte gratuit</b>'
      }
    }
  },
  beforeMount () {
    this.language = this.lang
  },
  methods: {
    changeLanguage: function (lang) {
      this.language = lang
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  height: 100vh;
  min-height: 600px;
  background-color: #f0f2f5;
  background-image:
    radial-gradient(at 0% 0%, hsla(21, 100%, 58%, 0.05) 0px, transparent 50%),
    radial-gradient(at 100% 0%, hsla(232, 50%, 18%, 0.05) 0px, transparent 50%),
    radial-gradient(at 100% 100%, hsla(212, 100%, 47%, 0.05) 0px, transparent 50%),
    radial-gradient(at 0% 100%, hsla(232, 50%, 18%, 0.05) 0px, transparent 50%),
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 80 80'%3E%3Cg fill='%239C92AC' fill-opacity='0.03'%3E%3Cpath d='M0 0h40v40H0V0zm40 40h40v40H40V40zm0-40h2V2h-2V0zm0 4h2v2h-2V4zm0 4h2v2h-2V8zm0 4h2v2h-2v-2zm0 4h2v2h-2v-2zm0 4h2v2h-2v-2zm0 4h2v2h-2v-2zm0 4h2v2h-2v-2zm0 4h2v2h-2v-2zm0 4h2v2h-2v-2zm0 4h2v2h-2v-2zm0 4h2v2h-2v-2zm0 4h2v2h-2v-2zm0 4h2v2h-2v-2zm2-2h2v2h-2v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2zm-38 0h2v2h-2v-2zm-4 0h2v2h-2v-2zm-4 0h2v2h-2v-2zm-4 0h2v2h-2v-2zm-4 0h2v2h-2v-2zm-4 0h2v2h-2v-2zm-4 0h2v2h-2v-2zm-4 0h2v2h-2v-2zm-4 0h2v2h-2v-2zm-4 0h2v2h-2v-2zm-4 0h2v2h-2v-2zm-4 0h2v2h-2v-2zm-4 0h2v2h-2v-2zm-4 0h2v2h-2v-2z'/%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
  font-family: "Quicksand", sans-serif;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.main-section {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.form-container {
  padding: 0;
  max-width: 900px;
  perspective: 1000px;
}

.card-container {
  background: white;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 24px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }
}

.form__description {
  height: 100%;
  min-height: 550px;
  background: linear-gradient(135deg, #171e44 0%, #2a356d 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  position: relative;
  overflow: hidden;
  transition: all 0.5s ease;

  .visual-elements {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;

    .svg-blob {
      position: absolute;
      background: rgba(255, 128, 40, 0.15);
      filter: blur(40px);
      border-radius: 50%;
    }

    .blob-1 {
      width: 300px;
      height: 300px;
      top: -100px;
      right: -100px;
      background: rgba(255, 128, 40, 0.2);
    }

    .blob-2 {
      width: 200px;
      height: 200px;
      bottom: -50px;
      left: -50px;
      background: rgba(0, 109, 240, 0.2);
    }

    .blob-3 {
      width: 150px;
      height: 150px;
      top: 40%;
      right: 10%;
      background: rgba(255, 255, 255, 0.1);
    }

    .floating-icons {
      position: absolute;
      width: 100%;
      height: 100%;

      .f-icon {
        position: absolute;
        width: 80px;
        height: 80px;
        opacity: 0.4;
        animation: float 6s ease-in-out infinite;

        svg {
          width: 100%;
          height: 100%;
        }
      }

      .icon-1 { top: 15%; left: 15%; animation-delay: 0s; }
      .icon-2 { top: 20%; right: 15%; animation-delay: 2s; }
      .icon-3 { bottom: 20%; left: 20%; animation-delay: 4s; }
      .icon-4 { bottom: 15%; right: 20%; animation-delay: 1s; }
    }
  }

  @keyframes float {
    0%, 100% { transform: translateY(0) rotate(0); }
    50% { transform: translateY(-20px) rotate(10deg); }
  }

  .description-content {
    position: relative;
    z-index: 1;
    text-align: center;

    .brand-logo {
      height: 70px;
      filter: drop-shadow(0 4px 6px rgba(0,0,0,0.1));
    }

    .description-text {
      font-size: 1.1rem;
      line-height: 1.6;
    }

    .stats-mini {
      display: flex;
      justify-content: center;
      gap: 30px;

      .stat-item {
        display: flex;
        flex-direction: column;
        align-items: center;

        .stat-value {
          font-size: 1.5rem;
          font-weight: 800;
          color: #ff8028;
          display: block;
        }

        .stat-label {
          font-size: 0.75rem;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          color: rgba(255, 255, 255, 0.6);
        }
      }
    }
  }
}

.form__content {
  padding: 50px 40px;
  background: white;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .login-title {
    font-size: 1.75rem;
    font-weight: 800;
    color: #171e44;
    margin-bottom: 0.5rem;
    letter-spacing: -0.025em;
  }

  .title-underline {
    width: 40px;
    height: 4px;
    background-color: #ff8028;
    margin: 0 auto;
    border-radius: 2px;
  }
}

.login-buttons-container {
  max-width: 340px;
  margin: 0 auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  & > * {
    width: 100%;
    margin-bottom: 1.25rem;
    display: block;
    transition: transform 0.2s ease;

    &:hover {
      transform: translateY(-2px);
    }
  }

  .social-button {
    ::v-deep button {
      border-radius: 12px;
      font-weight: 600;
      padding: 12px;
    }
  }

  .otp-button {
    ::v-deep button {
      border-radius: 12px;
      font-weight: 600;
      padding: 12px;
    }
  }

  ::v-deep .button-component {
    width: 100%;
  }
}

.divider {
  display: flex;
  align-items: center;
  text-align: center;
  margin: 1.25rem 0;
  color: #94a3b8;
  width: 100%;

  &::before,
  &::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid #e2e8f0;
  }

  span {
    padding: 0 15px;
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }
}

.policy-text {
  font-size: 0.75rem;
  color: #94a3b8;
  text-align: center;
  line-height: 1.5;
  max-width: 280px;
  margin: 0 auto;
}

.signup-section {
  .motivation-text {
    font-size: 0.95rem;
    font-weight: 600;
    color: #475569;
    text-align: center;
  }

  .signup-button {
    ::v-deep button {
      border-radius: 12px;
      font-weight: 700;
      padding: 12px;
    }
  }
}

/* Animations */
.fade-up-enter-active, .fade-up-leave-active {
  transition: opacity 0.6s cubic-bezier(0.16, 1, 0.3, 1), transform 0.6s cubic-bezier(0.16, 1, 0.3, 1);
}
.fade-up-enter {
  opacity: 0;
  transform: translateY(20px);
}

.footer-links {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;

  a {
    font-size: 0.85rem;
    color: #6c757d;
    transition: color 0.2s;

    &:hover {
      color: #006df0;
      text-decoration: none;
    }
  }
}

@media (max-width: 767.98px) {
  .content {
    height: auto;
    min-height: 100vh;
    overflow: auto;
    padding-bottom: 80px;
  }
  .form-container {
    margin-top: 2vh;
    padding: 15px;
  }

  .form__content {
    padding: 30px 20px;
  }
}
</style>
